var render, staticRenderFns
import script from "./v-chip.vue?vue&type=script&lang=js&"
export * from "./v-chip.vue?vue&type=script&lang=js&"
import style0 from "./v-chip.vue?vue&type=style&index=0&id=631c04a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports